<template>
  <div>
    <div class="container">
      <div class="kuang">
        <div class="tit">
          <img src="@/assets/layout/titlelogo.png" alt="" />
          <div class="txt">
            <p>社科普及工作管理平台</p>
          </div>
        </div>

        <div class="tabs">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="忘记密码" force-render>
              <div style="padding-top: 15px">
                <a-input
                  v-model="dataInfo.phone"
                  placeholder="请输入您的手机号"
                >
                </a-input>
                <div class="interval"></div>
                <div class="send-code">
                  <a-input
                  style="width:220px"
                    v-model="dataInfo.verificationCode"
                    placeholder="请输入验证码"
                  >
                  </a-input>
                  <a-button
                    v-if="!rFlag"
                    style="
                      background-color: #007651;
                      color: #fff;
                      width: 131px !important;
                    "
                    @click="sendSms"
                    >获取验证码</a-button
                  >
                  <a-button
                    v-if="rFlag"
                    disabled
                    style="
                      background-color: #007651;
                      color: #fff;
                      width: 131px !important;
                    "
                    >{{ timeValue }}秒后重新获取</a-button
                  >
                </div>

                <div class="interval"></div>
                <a-input
                  v-model="dataInfo.passWord"
                  type="password"
                  placeholder="密码"
                >
                </a-input>
                <span  style="color:#bfbfbf ;font-size: 10px;font-weight: 600;padding-left: 5px;">密码要求：大写字母+小写字母+数字+特殊字符，8位以上</span>
                <div class="interval" style="height:1rem" ></div>
                <a-input
                  v-model="dataInfo.rePassWord"
                  type="password"
                  placeholder="确认密码"
                >
                </a-input>
                <div class="interval"></div>
                <button class="loginbtn" @click="confirm">确认</button>
                <div class="interval"></div>
                <div class="choose">
                  <p style="color: #007651" @click="registerClick(1)">
                    注册账户
                  </p>
                  <span>|</span>
                  <p style="color: #007651" @click="registerClick(0)">去登陆</p>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { decUserForgetPasswordApi, decUserSendSmsApi } from "@/api/declare.js";
import md5 from "js-md5";
export default {
  name: "Register",
  data() {
    return {
       rFlag: false,
        timeValue: 60,
      dataInfo: {
       
        userName: "",
        passWord: "",
        rePassWord: "",
        chargeName: "" /* 单位负责人姓名 */,
        chargeMobile: "" /* 单位联系人姓名 */,
        contactName: "" /* 单位联系人姓名 */,
        contactMobile: "" /* 单位联系人手机 */,
        selsecinfo: undefined /* 申报入口 */,
        email: "",
        phone: "",
        bankAccount: "" /* 银行账户 */,
        bankAddress: "" /* 开户行 */,
        bankName: "" /* 户名 */,
        verificationCode: "" /* 验证码 */,
        codeKey: "",
      },
      declareList: [
        {
          likeName: "123",
          id: 1,
        },
      ] /* 申报入口列表 */,
      mobile: "", //手机号
      likeName: "", //昵称
      VerificationCode: "", //验证码
      email: "", //邮箱
      password: "", //密码
      passwords: "", //密码
      codeKey: "", //验证码串
      buttonName: "发送验证码", //发送验证码
      isDisabled: false,
      second: 60,
    };
  },
  methods: {
    registerClick(val) {
      this.$emit("backLogin", val);
    },
    handleChange() {},
    countdown() {
      this.clearId = setInterval(() => {
        this.timeValue--;
        if (this.timeValue == 0) {
          clearInterval(this.clearId);
          this.timeValue = 60;
          this.rFlag = false;
        }
      }, 1000);
    },
    sendSms() {
      if (this.dataInfo.phone == "") {
        this.$message.warn("请填写您的手机号");
        return;
      }
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(this.dataInfo.phone)) {
        this.$message.error("请正确填写您的手机号码！");
        this.dataInfo.phone = "";
        return;
      }
      let params = {
        mobile: this.dataInfo.phone,
      };
      decUserSendSmsApi(params).then((res) => {
        if (res.status) {
          this.$message.success(res.message);
          this.rFlag = true;
          this.countdown();
          this.dataInfo.codeKey = res.data.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    confirm() {
      if (this.dataInfo.phone == "") {
        this.$message.warn("请输入您的手机号");
        return;
      }
      if (this.dataInfo.verificationCode == "") {
        this.$message.warn("请输入验证码");
        return;
      }
      if (this.dataInfo.passWord == "") {
        this.$message.warn("请输入密码");
        return;
      }
      if (this.dataInfo.rePassWord == "") {
        this.$message.warn("请确认密码");
        return;
      }
      if (this.dataInfo.passWord != this.dataInfo.rePassWord) {
        this.$message.error("两次密码不一致，请重新输入");
        this.dataInfo.passWord = "";
        this.dataInfo.rePassWord = "";
        return;
      }
      let params = {
        userPhone: this.dataInfo.phone,
        password: md5(this.dataInfo.passWord),
      };
      let params1 = {
        codeValue: this.dataInfo.verificationCode,
        codeKey: this.dataInfo.codeKey,
      };
      decUserForgetPasswordApi(params1, params).then((res) => {
        if (res.status) {
          this.$message.success(res.message);
          setTimeout(() => {
            this.$emit("backLogin", 0);
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //忘记密码
    secret() {
      this.$emit("forget");
    },
  },
};
</script>
<style scoped lang="scss">
@import "./index.scss";
</style>
